const Footer = () => {
  return (
    <footer className="bg-gray-800 text-gray-300 py-6 text-center">
      <p>© {new Date().getFullYear()} MyApp Inc. | All rights reserved.</p>
      <div className="mt-2 space-x-4">
        <a href="/privacy" className="hover:text-white">
          Privacy Policy
        </a>
        <a href="/terms" className="hover:text-white">
          Terms of Service
        </a>
      </div>
    </footer>
  );
};

export default Footer;